<template>
  <div>
    <b-row class="content-header mb-2">
      <!-- Content Left -->
      <b-col class="content-header-left" cols="12" md="9">
        <breadcrumb />
      </b-col>

      <!-- Content Right -->
      <b-col class="content-header-right text-md-right" md="3" cols="12">
        <b-button
          @click="showFormModal(null)"
          class="px-3 text-capitalize"
          variant="primary"
        >
          <feather-icon size="16" icon="PlusIcon" class="mr-50" />
          ایجاد ویژگی های تور گردشگرری
        </b-button>
      </b-col>
    </b-row>
    <div v-if="properties">
      <div class="d-flex justify-content-between align-items-center">
         <per-page class="col-sm-12 col-md-3 col-lg-2" v-model="perPage" />
        <!-- <search
          ref="toursSearchComponent"
          class="w-50"
          v-model="searchInput"
        /> -->
      </div>

      <b-table-simple responsive>
        <b-thead>
          <b-tr>
            <b-th>عکس آیکن</b-th>
            <b-th>آیکن</b-th>
            <b-th>عنوان</b-th>
            <b-th>توضیحات</b-th>
            <b-th>نمایش در صفحه</b-th>
            <b-th>تاریخ</b-th>
            <b-th>وضعیت</b-th>
            <b-th>عملیات</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-for="category in properties" :key="category.id">
            <b-th>
              <img
              v-if="category.image.path"
                style="border-radius: 15px; width: 35px"
                :src="$http.defaults.fileUrl + category.image.path"
            /></b-th>
            <b-th >{{ category.icon }}</b-th>
            <b-td>{{ category.name }}</b-td>
            <b-td>{{ category.description }}</b-td>

            <b-td>
              <b-col
                  class="d-flex align-items-center pl-0"
                  :class="
                  category.show_index_page != '0' ? 'text-success' : 'text-danger'
                "
              >
                {{ category.show_index_page == "1" ? "" : "غیر" }}فعال
              </b-col></b-td
            >

            <b-td>
              {{
                new Date(category.created_at).toLocaleString("fa-IR", {
                  timeZone: "Iran",
                })
              }}
            </b-td>
            <b-td>
              <b-col
                class="d-flex align-items-center pl-0"
                :class="
                  category.status != 'active' ? 'text-danger' : 'text-success'
                "
              >
                {{ category.status == "active" ? "" : "غیر" }}فعال
              </b-col></b-td
            >
            <b-td>
              <b-col class="d-flex align-items-center">
<!--                <router-link
                    :to="{ name: 'categorySpaceStatistics', params: { id: category.id,name:category.name } }"
                    variant="flat-secondary"
                    class="font-weight-bolder btn"
                >
                  <BIconCalendar />
                </router-link>-->
                <b-button
                  @click="showConfirmModal(category)"
                  variant="flat-danger"
                  class="font-weight-bolder"
                >
                  <feather-icon icon="Trash2Icon" size="20" />
                </b-button>
                <b-button
                  @click="showFormModal(category)"
                  variant="flat-secondary"
                  class="font-weight-bolder"
                >
                  <feather-icon icon="Edit2Icon" size="20" />
                </b-button> </b-col
            ></b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
      <pagination
        ref="toursPaginationComponent"
        v-model="page"
        :paginationData="paginationData"
      />
    </div>
    <b-sidebar
      width="500px"
      v-model="formModal"
      right
      backdrop
      shadow
      bg-variant="white"
    >
      <template #header>
        <div class="w-100">
          <div class="text-right">
            <b-button
              style="background-color: rgba(75, 75, 75, 0.12)"
              @click="formModal = false"
              variant="flat-dark"
              class="btn-icon rounded-circle mr-1"
            >
              <feather-icon icon="XIcon" size="20" />
            </b-button>
          </div>
          <div class="mr-1 sidebarHeaderTitleDiv">
            <h3 class="text-capitalize">
              {{ editMode ? "ویرایش ویژگی" : "ایجاد ویژگی" }}
            </h3>
          </div>
        </div>
      </template>
      <b-container class="">
        <b-form-group class="mt-1">
          <label for="name" class="text-capitalize"> عنوان : </label>
          <b-form-input @input="removeErrors('name')" id="name" v-model="categoryInput.name" type="text" />
           <ErrorMessage
            errorType="name"
            :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>
        <b-form-group class="mt-1">
          <label for="slug" class="text-capitalize"> اسلاگ | slug : </label>
          <b-form-input @input="removeErrors('slug')" id="slug" v-model="categoryInput.slug" type="text" />
            <ErrorMessage
            errorType="slug"
            :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>
        <b-form-group class="mt-1 col-md-6" v-slot="{ ariaDescribedby }">
          <label for="province_status" class="text-capitalize"> وضعیت : </label>
          <b-form-checkbox
            v-model="categoryInput.status"
            :aria-describedby="ariaDescribedby"
            value="active"
            @input="removeErrors('status')"
            >فعال</b-form-checkbox
          >
          <b-form-checkbox
            v-model="categoryInput.status"
            :aria-describedby="ariaDescribedby"
            value="inactive"
            @input="removeErrors('status')"
            >پیش نویس</b-form-checkbox
          >
          <ErrorMessage
            errorType="status"
            :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>






        <b-form-group class="mt-1 col-md-6" v-slot="{ ariaDescribedby }">
          <label for="province_status" class="text-capitalize"> وضعیت : </label>

          <b-form-checkbox
              v-model="categoryInput.show_index_page"
              :aria-describedby="ariaDescribedby"
              value="1"
              @input="removeErrors('show_index_page')"
          > نمایش در صفحه اصلی</b-form-checkbox
          >
          <b-form-checkbox
              v-model="categoryInput.show_index_page"
              :aria-describedby="ariaDescribedby"
              value="0"
              @input="removeErrors('show_index_page')"
          >
            عدم نمایش در ص اصلی
          </b-form-checkbox
          >
          <ErrorMessage
              errorType="status"
              :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>


        <b-form-group class="mt-1">
          <label for="description" class="text-capitalize"> توضیحات : </label>
          <b-form-input
            id="description"
            v-model="categoryInput.description"
            type="text"
            @input="removeErrors('description')"
          />
          <ErrorMessage
            errorType="description"
            :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>
        <b-form-group class="mt-1">
          <label for="body" class="text-capitalize"> آیکن : </label>
          <b-form-input @input="removeErrors('icon')"  id="body" v-model="categoryInput.body" type="text" />
              <ErrorMessage
            errorType="icon"
            :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>
        <b-form-group class="">
          <label for="imageIcon" class="text-capitalize">
            آپلود تصویر ایکون:
          </label>
          <FilePicker
            @inputFile="inputIconImageFile"
            :url="iconImageurl"
            ref="iconImageFilePicker"
          ></FilePicker>
          <ErrorMessage
            errorType="image"
            :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>
      </b-container>
      <template #footer>
        <div class="d-flex align-items-center justify-content-end px-2 py-1">
          <b-button
            class="text-capitalize mr-2"
            @click="formModal = false"
            variant="outline-dark"
          >
            {{ $t("cancel") }}
          </b-button>
          <b-button variant="primary" @click="submitForm()">
            <div v-if="submitLoading" class="px-1">
              <b-spinner small style="width: 1.3rem; height: 1.3rem" />
              <span class="sr-only">Loading...</span>
            </div>
            <span v-else class="text-capitalize">
              {{ $t("submit") }}
            </span>
          </b-button>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BAvatar,
  BButton,
  BSpinner,
  BSidebar,
  BContainer,
  BFormTextarea,
  BFormCheckbox,
  BTableSimple,
  BThead,
  BTbody,
  BFormSelect,
  BTr,
  BTh,
  BTd, BIconCalendar,
} from "bootstrap-vue";
import PerPage from "@/components/PerPage.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Pagination from "@/components/Pagination.vue";
import Search from "@/components/Search.vue";
import TableHead from "@/components/TableHead.vue";
import vSelect from "vue-select";
import ErrorMessage from "@/components/ErrorMessage.vue";
import FilePicker from "@/components/FilePicker.vue";

export default {
  components: {
    BIconCalendar,
    BRow,
    BCol,
    PerPage,
    BFormGroup,
    BFormInput,
    BCard,
    BAvatar,
    BButton,
    BFormSelect,
    Breadcrumb,
    Pagination,
    Search,
    TableHead,
    BSpinner,
    BSidebar,
    BContainer,
    BFormTextarea,
    vSelect,
    ErrorMessage,
    BFormCheckbox,
    FilePicker,
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
  },
  data() {
    return {

      optionsShow:[
        { value: null, text: 'انتخاب نمایش در ص اصلی' },
        { value: '0', text: 'عدم نمایش در صفحه اصلی' },
        { value: '1', text: 'نمایش در صفحه اصلی' },
      ],

      iconImageurl:"",
      errorMessage: {},
      perPage: 10,
      page: 1,
      buildings: [],
      properties: null,
      defaultAvatar: require("@/assets/images/avatars/default.png"),
      cancelToken: undefined,
      sortBy: "",
      sortDir: "",
      searchInput: "",
      paginationData: null,
      tableHeadings: [
        {
          title: "تصویر آیکن",
          slug: "image_icon",
          sortable: false,
        },
        {
          title: "آیکن",
          slug: "icon",
          sortable: false,
        },
        {
          title: "عنوان",
          slug: "name",
          sortable: true,
        },
        {
          title: "توضیحات",
          slug: "description",
          sortable: true,
        },
        {
          title: "نمایش در صفحه",
          slug: "show_index_page",
          sortable: true,
        },
        {
          title: "تاریخ ایجاد",
          slug: "created_at",
          sortable: true,
        },

        {
          title: "وضعیت",
          slug: "status",
          sortable: false,
        },
        {
          title: "actions",
          sortable: false,
        },
      ],

      OpenIndicator: {
        render: (createElement) =>
          createElement("feather-icon", { attrs: { icon: "ChevronDownIcon" } }),
      },
      companies: [],
      buildingsCancelToken: undefined,
      categoryInput: {
        id: "",
        name: "",
        slug:"",
        description: "",
        status:"",
        image: null,
        icon: "",
        show_index_page:""
      },
      editMode: false,
      formModal: false,
      submitLoading: false,
    };
  },
  mounted() {
    this.$store.commit("verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED", false);
    this.getCategories();
    this.getBuildings();
  },
  watch: {
    searchInput(value) {
      this.page = 1;
      this.getCategories();
    },
    perPage(value) {
      this.page = 1;
      this.getCategories();
    },
    page(value) {
      this.getCategories();
    },
  },
  methods: {
    inputIconImageFile(file) {
      this.removeErrors("image");
      this.categoryInput.image = file;
    },
    removeErrors(data) {
      if (
        typeof this.errorMessage[data] !== "undefined" &&
        this.errorMessage[data].length > 0
      ) {
        // this.errorMessage[data][0]="salllam"
        delete this.errorMessage[data];
        this.errorMessage = Object.assign(
          {},
          this.errorMessage,
          this.errorMessage
        );
        console.log(data, this.errorMessage);
      }
    },
    sort(args) {
      this.page = 1;
      this.sortBy = args.sortBy;
      this.sortDir = args.sortDir;
      this.getCategories();
    },

    async getCategories() {
      if (typeof this.cancelToken != typeof undefined) {
        this.cancelToken.cancel("Operation canceled due to new request.");
      }
      //Save the cancel token for the current request
      this.cancelToken = this.$http.CancelToken.source();

      let data = {
        // search: this.searchInput,
        // per_page: this.perPage,
        // page: this.page,
        // sort_by: this.sortBy,
        // sort_dir: this.sortDir,
      };

      const requestData = {
        method: "get",
        url: "/admin/tours/properties",
        // params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
        .then((response) => {
          let data = response.data;
          this.properties = data.data;
          this.paginationData = data.meta;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    showConfirmModal(category) {
      this.$bvModal
        .msgBoxConfirm(
          `آیا از حذف ویژگی مطمئن هستید ؟  : ${category.name}.`,
          {
            title: this.$t("Please Confirm"),
            size: "sm",
            okVariant: "primary",
            okTitle: this.$t("Yes"),
            cancelTitle: this.$t("No"),
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then(async (confirmed) => {
          if (confirmed) {
            let residenceIndex = 0;
            this.properties = await this.properties.filter(
              (residenceItem, index) => {
                if (residenceItem.id == category.id) {
                  residenceIndex = index;
                }
                return residenceItem.id !== category.id;
              }
            );

            const requestData = {
              method: "delete",
              url: `/admin/tours/properties/${category.id}`,
            };
            this.$http(requestData)
              .then((response) => {
                this.$bvToast.toast(
                  `ویژگی: ${category.name}  با موفقیت حذف شد.`,
                  {
                    title: this.$t("Done"),
                    variant: "success",
                    solid: true,
                  }
                );
              })
              .catch((err) => {
                let message = this.$t("Unable to delete!");
                if (
                  err.response &&
                  err.response.data &&
                  err.response.data.message
                )
                  message = err.response.data.message;
                this.$bvToast.toast(message, {
                  title: this.$t("Error"),
                  variant: "danger",
                  solid: true,
                });
                this.properties.splice(residenceIndex, 0, category);
              });
          }
        });
    },
    showFormModal(category) {
      if (category) {
        this.categoryInput = {
          id: category.id,
          name: category.name,
          slug:category.slug,
          description: category.description,
          status: category.status,
          show_index_page: category.show_index_page,
          image: null,
          icon: category.icon,
        };
        this.$refs.iconImageFilePicker.clearFileInput()
        this.iconImageurl=category.image.path
        this.editMode = true;
      } else {
        this.categoryInput = {
          name: "",
          slug: "",
          description: "",
          status: "",
          show_index_page: "",
          image: "",
          icon: "",
        };
        this.$refs.iconImageFilePicker.clearFileInput()
        this.iconImageurl=""
        this.editMode = false;
      }
      this.formModal = true;
    },
    submitForm() {
      if (this.submitLoading) return;
      let errorMessage = null;
      if (!errorMessage && !this.categoryInput.name) {
        errorMessage = "لطفا نام ویژگی را وارد کنید";
      }
      if (!errorMessage && !this.categoryInput.slug) {
        errorMessage = "لطفا اسلاگ ویژگی را وارد کنید";
      }

      let formData = new FormData();

      if (this.categoryInput.name) {
        formData.append("name", this.categoryInput.name);
      }
      if (this.categoryInput.slug) {
        formData.append("slug", this.categoryInput.slug);
      }
      if (this.categoryInput.status) {
        formData.append("status", this.categoryInput.status);
      }
      if (this.categoryInput.show_index_page) {
        formData.append("show_index_page", this.categoryInput.show_index_page);
      }
      if (this.categoryInput.description) {
        formData.append("description", this.categoryInput.description);
      }
      if (this.categoryInput.image) {
        formData.append("image", this.categoryInput.image);
      }
      if (this.categoryInput.icon) {
        formData.append("icon", this.categoryInput.icon);
      }
      if (errorMessage) {
        this.$bvToast.toast(errorMessage, {
          title: this.$t("Error"),
          variant: "danger",
          solid: true,
        });
        return;
      }

      this.submitLoading = true;

      const requestData = {
        method: this.editMode ? "post" : "post",
        url: this.editMode
          ? `/admin/tours/properties/update/${this.categoryInput.id}`
          : `/admin/tours/properties`,
        data: formData,
      };

      this.$http(requestData)
        .then((response) => {
          let message = "ویژگی با موفقیت اضافه شد";
          if (this.editMode) message = "ویژگی با موفقیت ویرایش شد";
          this.$bvToast.toast(message, {
            title: this.$t("Done"),
            variant: "success",
            solid: true,
          });
          if (!this.editMode && this.buildings && this.buildings.length > 0) {
            this.$refs.toursPaginationComponent.clear();
            // this.$refs.toursSearchComponent.clear();
            this.$refs.toursTableHeadComponent.clear();
            this.page = 1;
            this.searchInput = "";
            this.sortBy = "";
            this.sortDir = "";
          }

          this.submitLoading = false;
          this.formModal = false;
          this.getCategories();
        })
        .catch((err) => {
          let message = "خطا در ایجاد ویژگی";
          if (this.editMode) message = "خطا در ویرایش ویژگی";
        if (
            err.response &&
            err.response.data &&
            err.response.data.response &&
            err.response.data.response.message
          )
            message = err.response.data.response.message;
          if (
            err.response &&
            err.response.data &&
            err.response.data.response &&
            err.response.data.response.meta &&
            err.response.data.response.meta.errors
          )
            this.errorMessage = err.response.data.response.meta.errors;
          console.log("this.errorMessage", this.errorMessage);

          this.$bvToast.toast(message, {
            title: this.$t("Error"),
            variant: "danger",
          });
          this.submitLoading = false;
          console.log(err);
        });
    },
    getBuildings(search, loading) {
      if (typeof this.buildingsCancelToken != typeof undefined) {
        this.buildingsCancelToken.cancel(
          "Operation canceled due to new request."
        );
      }
      //Save the cancel token for the current request
      this.buildingsCancelToken = this.$http.CancelToken.source();

      let data = {
        search: search,
        per_page: 10,
        page: 1,
      };

      const requestData = {
        method: "get",
        url: "buildings",
        params: data,
        cancelToken: this.buildingsCancelToken.token,
      };
      this.$http(requestData)
        .then((response) => {
          let data = response.data.data;
          this.buildings = data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
